import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Navigation } from 'lucide-react';
import { COMPANY, PRIMARY_AREAS, slugify } from '../data/mock';

const OSM_SRC =
  'https://www.openstreetmap.org/export/embed.html?bbox=-82.2%2C42.5%2C-78.0%2C44.7&layer=mapnik&marker=43.4643%2C-80.5204';

const ServiceAreaMap = () => {
  return (
    <div className="grid lg:grid-cols-5 gap-8 items-stretch">
      <div className="lg:col-span-3 rounded-[1.5rem] overflow-hidden border border-[#e3ecda] shadow-lg bg-white">
        <iframe
          title="360 Mold Services coverage map – Southern Ontario"
          src={OSM_SRC}
          className="w-full h-[380px] lg:h-[440px] border-0"
          loading="lazy"
        />
      </div>
      <div className="lg:col-span-2 dark-section text-white rounded-[1.5rem] p-8 flex flex-col justify-center">
        <div className="flex items-center gap-2 text-[#8bd44a] font-semibold">
          <Navigation className="h-5 w-5" /> Coverage Map
        </div>
        <h3 className="mt-3 text-2xl font-bold">Based in Waterloo, serving {COMPANY.region}</h3>
        <p className="mt-3 text-[#c3d2c6] leading-relaxed">
          From the Region of Waterloo out to the Greater Toronto Area, Niagara and beyond — our
          certified inspectors come to you.
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          {PRIMARY_AREAS.map((a) => (
            <Link
              key={a}
              to={`/service-areas/${slugify(a)}`}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 border border-white/10 text-sm hover:bg-[#8bd44a] hover:text-[#13251b] transition-colors"
            >
              <MapPin className="h-3.5 w-3.5 text-[#8bd44a]" /> {a}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceAreaMap;
